import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import CustomIcon, { AssetTypes } from "../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  titleKey: string;
  iconSrc: AssetTypes;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  badge?: React.ReactNode;
}

function OrderHistorySectionCard({
  children,
  iconSrc,
  titleKey,
  actions,
  badge,
}: Props) {
  const { tTitle } = useI18nHelper();

  return (
    <Flex
      padding={"16px"}
      flexDirection={"column"}
      gap={"20px"}
      boxShadow={"0 0 0 0.5px #D4D4D1, 0 2px 4px 0 rgba(0, 0, 0, 0.10)"}
      borderRadius={"8px"}
      background={"#FFFFFF"}
    >
      <Flex justifyContent={"space-between"} alignItems={"center"}>
        <Flex gap={"8px"} alignItems={"center"}>
          <Box padding={"8px"} background={"#F7F9FA"} borderRadius={"8px"}>
            <CustomIcon
              src={iconSrc}
              width={24}
              height={24}
              color={"#444444"}
            />
          </Box>
          <Text textStyle={"body-lg-bold"} color={"#444444"}>
            {tTitle(titleKey)}
          </Text>
          {badge}
        </Flex>
        <Flex gap={"16px"}>{actions}</Flex>
      </Flex>
      {children}
    </Flex>
  );
}

export default OrderHistorySectionCard;
